import Helper from '@ember/component/helper';
import { service } from '@ember/service';
export default class PreferredLocale extends Helper {
  @service intl;

  compute() {
    return this.intl.primaryLocale;
  }
}
